import { Mail, Phone, MapPin, Clock } from "lucide-react";

const contactInfo = [
  {
    icon: Phone,
    title: "Telefono",
    value: "+39 329 265 6988",
    href: "tel:+393292656988",
    description: "Lun-Ven: 8:00-18:00"
  },
  {
    icon: Mail,
    title: "Email",
    value: "info@scavoneservicesrl.com",
    href: "mailto:info@scavoneservicesrl.com",
    description: "Rispondiamo entro 24h"
  },
  {
    icon: MapPin,
    title: "Indirizzo",
    value: "Via XXV Aprile, 1",
    href: "https://maps.google.com/?q=Via+XXV+Aprile+1+Quarto+d'Altino+Italy",
    description: "Quarto d'Altino, VE 30020"
  },
  {
    icon: Clock,
    title: "Orari",
    value: "Lun-Ven: 8:00-18:00",
    href: null,
    description: "Pronto Intervento 24/7"
  }
];

const ContactSection = () => {
  return (
    <section id="contatti" className="py-24 bg-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#5abb3d] font-semibold tracking-[0.2em] uppercase text-sm">
            Contatti
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-[#29383d] mt-4 tracking-tight">
            Siamo Qui per Te
          </h2>
          <p className="text-[#394b52] mt-4 max-w-2xl mx-auto leading-relaxed">
            Contattaci per qualsiasi informazione o richiesta. Il nostro team è pronto ad aiutarti.
          </p>
        </div>

        {/* Contact Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {contactInfo.map((info, index) => (
            <div
              key={info.title}
              className={`p-6 bg-[#f8f9fa] rounded-2xl border border-[#e5e7eb] hover:shadow-lg hover:-translate-y-1 transition-all duration-300 opacity-0 animate-fade-in-up stagger-${index + 1}`}
              data-testid={`contact-card-${info.title.toLowerCase()}`}
            >
              <div className="w-12 h-12 bg-[#5abb3d] rounded-xl flex items-center justify-center mb-4">
                <info.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-outfit text-lg font-semibold text-[#29383d] mb-2">
                {info.title}
              </h3>
              {info.href ? (
                <a
                  href={info.href}
                  target={info.title === "Indirizzo" ? "_blank" : undefined}
                  rel={info.title === "Indirizzo" ? "noopener noreferrer" : undefined}
                  className="text-[#5abb3d] font-medium hover:underline block"
                  data-testid={`contact-link-${info.title.toLowerCase()}`}
                >
                  {info.value}
                </a>
              ) : (
                <span className="text-[#29383d] font-medium block">{info.value}</span>
              )}
              <span className="text-[#394b52] text-sm mt-1 block">{info.description}</span>
            </div>
          ))}
        </div>

        {/* Map */}
        <div className="rounded-2xl overflow-hidden border border-[#e5e7eb] shadow-lg" data-testid="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2795.5!2d12.3742!3d45.5167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477956a6c7a0d0db%3A0x3cf9f3b0a2a0e0c0!2sVia%20XXV%20Aprile%2C%201%2C%2030020%20Quarto%20d&#39;Altino%20VE%2C%20Italy!5e0!3m2!1sen!2sus!4v1234567890"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Scavone Service E&J Location"
          />
        </div>

        {/* Service Area */}
        <div className="mt-12 text-center p-8 bg-[#29383d] rounded-2xl" data-testid="service-area-banner">
          <h3 className="font-outfit text-xl font-bold text-white mb-2">
            Zona Operativa
          </h3>
          <p className="text-white/80">
            Operiamo in tutto il <span className="text-[#5abb3d] font-semibold">Veneto</span>: 
            Venezia, Mestre, Treviso, Padova, Verona e province limitrofe.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
